<template>
  <div>
    <div class="flex justify-between items-center">
      <div class="text-lg">
        {{ product.quantity }} x
        <span v-if="phase3d_care_app">{{ product.variant_id }}</span
        ><span v-else>{{ product.sku }}</span>
      </div>
      <LoadingSpinner v-if="loading" class="text-gray-500" />
      <div
        v-else
        @click="expand = !expand"
        class="flex items-center space-x-2 text-gray-500 cursor-pointer"
      >
        <div v-if="expand">
          {{ refund.quantity }} x
          {{ (refund.totals.value + refund.totals.taxes) | currency }} =
        </div>
        <icon
          v-else
          set="solid"
          name="chevron-double-down"
          class="w-5 h-5 text-cool-gray-400"
        />
        <div class="text-lg">
          <div>
            {{
              (refund.quantity * (refund.totals.value + refund.totals.taxes))
                | currency
            }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="expand && !loading"
      class="flex justify-start items-stretch py-4 space-x-4 text-xs text-gray-500"
    >
      <div class="flex flex-col space-y-1">
        <div class="text-center">.</div>
        <div class="text-right">Value:</div>
        <div class="text-right">Taxes:</div>
      </div>

      <div class="flex flex-col space-y-1">
        <div class="text-center">Product</div>
        <div class="text-right">{{ refund.price.value | currency }}</div>
        <div class="text-right">{{ refund.price.taxes | currency }}</div>
      </div>

      <div class="flex items-center">
        <div class="text-lg">+</div>
      </div>

      <div class="flex flex-col space-y-1">
        <div class="text-center">Wnty</div>
        <div class="text-right">{{ refund.warranty.value | currency }}</div>
        <div class="text-right">{{ refund.warranty.taxes | currency }}</div>
      </div>

      <div class="flex items-center">
        <div class="text-lg">+</div>
      </div>

      <div class="flex flex-col space-y-1">
        <div class="text-center">O/size</div>
        <div class="text-right">
          {{ refund.oversizedHandlingFee.value | currency }}
        </div>
        <div class="text-right">
          {{ refund.oversizedHandlingFee.taxes | currency }}
        </div>
      </div>

      <div class="flex items-center">
        <div class="text-lg">-</div>
      </div>

      <div class="flex flex-col space-y-1">
        <div class="text-center">Disc.</div>
        <div class="text-right">{{ refund.discount.value | currency }}</div>
        <div class="text-right">{{ refund.discount.taxes | currency }}</div>
      </div>

      <div class="flex items-center">
        <div class="text-lg">+</div>
      </div>

      <div class="flex flex-col space-y-1">
        <div class="text-center">Ship.</div>
        <div class="text-right">{{ refund.shipping.value | currency }}</div>
        <div class="text-right">{{ refund.shipping.taxes | currency }}</div>
      </div>

      <div class="flex items-center">
        <div class="text-lg">=</div>
      </div>

      <div class="flex flex-col space-y-1">
        <div class="text-center">Total</div>
        <div class="text-right">{{ refund.totals.value | currency }}</div>
        <div class="text-right">{{ refund.totals.taxes | currency }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RefundValueProduct",
  filters: {
    currency(param) {
      param = isNaN(param) ? 0 : param;
      let formatted = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      }).format(param);
      return formatted.substring(0, formatted.length - 2);
    },
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    phase3d_care_app: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expand: false,
    };
  },
  computed: {
    refund() {
      return this.product.refund;
    },
  },
};
</script>
